import { LiveMeetingAttendanceConfirmationStatusEnum, LiveMeetingAttendanceConfirmationTypeEnum, LiveVideoCard } from 'app/types/cards/LiveVideoCard';
import { ConditionalLinkTargets, ConditionalLinkTypes } from 'components/conditionalLink';
import { IconsTypes } from 'components/icons';
// import { VideoProviderEnum } from 'features/contents';
// import { TeachersCardState } from 'features/teachers';

export enum LiveStatusEnum {
  Scheduled = 1,
  InProgress = 2,
  RecordedNotAvailable = 3,
  Recorded = 4,
  RecordNotAvailable = 5,
  Rescheduled = 6,
}

export enum LiveOrganizationTypeEnum {
  Default = 0,
  GroupByMonth = 1,
}

export interface LiveCardProps {
  liveUuid?: string;
  liveStatus?: LiveStatusEnum;
  date?: string;

  hat?: string;
  name: string;
  teacherName?: string;

  buttonLabel: string;
  buttonIcon: IconsTypes;

  image?: string;
  disabled?: boolean;
  showDate?: boolean;

  size?: 'small' | 'default' | 'large';
  theme?: 'light' | 'dark';

  link?: string;
  linkType: ConditionalLinkTypes;
  linkTarget?: ConditionalLinkTargets;

  hasConfirmation?: boolean;
  isConfirmation?: boolean;
  isConfirmationPage?: boolean;
  floatButton?: boolean;
  hideButton?: boolean;
  onLiveClick?: () => void;

  confirmationStatus: LiveMeetingAttendanceConfirmationStatusEnum;
  confirmationCodeExpiresAt?: string;
  confirmationAt?: string;
  productEnrolled?: boolean;
}

export interface LivesApiResponse {
  lives: LiveVideoCard[];
  productClassUuid: string;
}

export interface LivesState {
  lives: LiveVideoCard[];
  productClassUuid: string;
  liveCardDetails: LiveCardProps | null;
  openLiveConfirmation: boolean;
}

export interface UseLivesState {
  lives: LiveVideoCard[];
  setLives: (lives: LivesApiResponse) => void;
  clearLives: () => void;

  productClassUuid: string;

  liveCardDetails: LiveCardProps | null;
  setLiveCardDetails: (liveCardDetails: LiveCardProps | null) => void;
  clearLiveCardDetails: () => void;

  openLiveConfirmation: boolean;
  setOpenLiveConfirmation: (open: boolean, liveCardDetails: LiveCardProps | null) => void;

  sanitizeCardToLiveCard: (liveVideo: LiveVideoCard) => LiveCardProps | null;
  confirmAttendance: (
    liveUuid: string,
    confirmationCode?: string,
    confirmationType?: LiveMeetingAttendanceConfirmationTypeEnum
  ) => Promise<{
    apiResultCode: number;
    apiResultMessage: string;
  }>;
  fetchLive: (liveUuid: string, onEnd?: () => void) => Promise<any>;
}
